module.exports = __webpack_public_path__ + "static/icon_dota-2202fdb301891fc0f352104953ac2e52.png";